import { YearButton } from './styles';

type YearButtonItemProps = {
  year: number;
  isSelected: boolean;
  isInRange: boolean;
  isDisabled?: boolean;
  isUnderlined?: boolean;
  onClick: (year: number) => void;
};

export const YearButtonItem = ({
  year,
  isSelected,
  isInRange,
  isDisabled,
  isUnderlined,
  onClick,
}: YearButtonItemProps) => (
  <YearButton
    key={year}
    type="button"
    isSelected={isSelected}
    isInRange={isInRange}
    isDisabled={isDisabled}
    isUnderlined={isUnderlined}
    disabled={isDisabled}
    onClick={() => {
      onClick(year);
    }}
  >
    {year}
  </YearButton>
);
